import Vue from 'vue'
import Router from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import NewArrivalView from '@/views/NewArrivalView.vue'
import BrandsView from '@/views/BrandsView.vue'
import CategoryView from '@/views/CategoryView.vue'
import WeeklyRankingView from '@/views/WeeklyRankingView.vue'
import MonthlyRankingView from '@/views/MonthlyRankingView.vue'
import CompanyView from '@/views/CompanyView.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash', // モール環境含め全サイトで安全
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/new', name: 'new', component: NewArrivalView },
    { path: '/brands', name: 'brands', component: BrandsView },
    { path: '/category', name: 'category', component: CategoryView },
    { path: '/weekly-ranking', name: 'weekly', component: WeeklyRankingView },
    { path: '/monthly-ranking', name: 'monthly', component: MonthlyRankingView },
    { path: '/company', name: 'company', component: CompanyView }
  ],
  // ハッシュ遷移でもトップへ戻す
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})
